<template>
  <App :session="session">
    <h4>CIERRES</h4>

    <i class="load" v-if="loading"></i>

    <div class="scroll" v-if="!loading">
      <i class="icon fa-solid fa-briefcase"></i>
      <select class="input" v-model="selec_closed">
        <option disabled :value="null">Periodo de cálculo</option>
        <option v-for="(closed, i) in closeds" :value="closed" :key="i">
          {{ new Date(closed.date).toLocaleString() }}
        </option>
      </select>
      <br />
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button class="button" @click="report">Reporte</button>
      <br />
      <br />

      <div v-if="node">
        <p>{{ node.dni }} - {{ node.name }}</p>
        <p>Fecha: {{ new Date(selec_closed.date).toLocaleString() }}</p>
        <p>Rango obtenido: {{ node.rank }}</p>
        <p>Puntaje personal: {{ node.points }}</p>
        <p>Puntaje grupal: {{ node.total_arr }}</p>
        <!-- <p>Activación:
          <span v-if="node.activated">Full</span>
          <span v-else>Simple</span>
        </p> -->
        <br />
        <p>Residual Bs {{ node.residual_bonus.toFixed(2) }}</p>
        <br />
        <table>
          <thead>
            <tr>
              <th>Nivel</th>
              <th>Cédula</th>
              <th>Nombre</th>
              <th>Importe</th>
              <th>%</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, i) in node.residual_bonus_arr" :key="i">
              <td>{{ r.n + 1 }}</td>
              <td>{{ r.dni }}</td>
              <td>{{ r.name }}</td>
              <td>{{ r.val }}</td>
              <td>{{ r.r }}</td>
              <td>{{ r.amount }}</td>

              <!-- <td>{{ Number(r.r * 100).toFixed(2) }} %</td>
              <td>Bs{{ Number(r.val * r.r).toFixed(2) }}</td> -->
            </tr>
          </tbody>
        </table>
        <br />

        <!-- {{ selec_closed.aff_transactions.filter(e => e.user_id == node.id) }} -->

        <br>

        <p>Bono excedente: Bs {{ node.excedent_bonus || 0 }}</p>

        <br>

        <p v-if="node._pays">
          Bono alcance de rango: <br>
          <span v-for="_p in node._pays">
            {{ _p.name }}: Bs {{ _p.value }}
          </span>
        </p>



<!--         <p>Bono Afiliación</p> <br>

        <table>
          <thead>
            <tr>
              <th>Nivel</th>
              <th>Cédula</th>
              <th>Nombre</th>
              <th>Importe</th>
            </tr>
          </thead>
          <tbody v-if="selec_closed.aff_transactions">
            <tr v-for="t in selec_closed.aff_transactions.filter(e => e.user_id == node.id)">
              <td>{{ t.n }}</td>
              <td>{{ t._dni }}</td>
              <td>{{ t._name }}</td>
              <td>Bs {{ t.value }}</td>
            </tr>
          </tbody>
        </table> -->

      </div>
    </div>
  </App>
</template>

<script>
import App from '@/views/layouts/App'
import api from '@/api'

export default {
  components: {
    App,
  },
  data() {
    return {
      id: null,
      selec_closed: null,
      closeds: null,
      loading: true,
      node: null,
    }
  },
  computed: {
    session() {
      return this.$store.state.session
    },
  },
  filters: {
    date(val) {
      return new Date(val).toLocaleDateString()
      // return new Date(val).toLocaleString()
    },
  },
  async created() {
    // GET data
    const { data } = await api.Closeds.GET(this.session)
    console.log({ data })

    this.loading = false

    // error
    if (data.error && data.msg == 'invalid session') this.$router.push('/login')
    if (data.error && data.msg == 'unverified user')
      this.$router.push('/verify')

    // success
    this.$store.commit('SET_NAME', data.name)
    this.$store.commit('SET_LAST_NAME', data.lastName)
    this.$store.commit('SET_AFFILIATED', data.affiliated)
    this.$store.commit('SET_ACTIVATED', data.activated)
    this.$store.commit('SET__ACTIVATED', data._activated)
    this.$store.commit('SET_PLAN', data.plan)
    this.$store.commit('SET_COUNTRY', data.country)
    this.$store.commit('SET_PHOTO', data.photo)
    this.$store.commit('SET_TREE', data.tree)

    this.id = data.id
    this.closeds = data.closeds
  },

  methods: {
    report() {
      console.log('report')
      if (!this.selec_closed) return

      console.log(this.id)
      this.node = this.selec_closed.tree.find((e) => e.id == this.id)

      this.node.residual_bonus_arr = this.ordered(this.node.residual_bonus_arr)
    },

    ordered(arr) {
      console.log({ arr })

      arr.sort((a, b) => (a.n > b.n ? 1 : b.n > a.n ? -1 : 0))

      return arr
    },
  },
}
</script>
